import _ from 'lodash'

function iterateSideEffects (marketing, callback) {
  let changed = false
  let i

  if (marketing.defaultAreaCode) {
    i = -1

    if (marketing.areaCodes) {
      i = marketing.areaCodes.indexOf(marketing.defaultAreaCode)
    }

    if (i === -1) {
      callback({
        message: `The <strong>Default Area Code</strong> will be unset from <string>${marketing.defaultAreaCode}</strong>`,
        action: () => {
          marketing.defaultAreaCode = null
        }
      })

      changed = true
    }
  }

  if (marketing.defaultCity) {
    i = -1

    if (marketing.cities) {
      i = marketing.cities.indexOf(marketing.defaultCity)
    }

    if (i === -1) {
      callback({
        message: `The <strong>Default City</strong> will be unset from <string>${marketing.defaultCity}</strong>`,
        action: () => {
          marketing.defaultCity = null
        }
      })

      changed = true
    }
  }

  if (marketing.defaultZipCode) {
    i = -1

    if (marketing.zipCodes) {
      i = marketing.zipCodes.indexOf(marketing.defaultZipCode)
    }

    if (i === -1) {
      callback({
        message: `The <strong>Default Zip Code</strong> will be unset from <string>${marketing.defaultZipCode}</strong>`,
        action: () => {
          marketing.defaultZipCode = null
        }
      })

      changed = true
    }
  }

  if (marketing.defaultState) {
    i = -1

    if (marketing.states) {
      i = marketing.states.indexOf(marketing.defaultState)
    }

    if (i === -1) {
      callback({
        message: `The <strong>Default State</strong> will be unset from <string>${marketing.defaultState}</strong>`,
        action: () => {
          marketing.defaultState = null
        }
      })

      changed = true
    }
  }

  return changed
}

export default {
  getSideEffects (marketing, changes) {
    let changedMarketing

    if (changes) {
      changedMarketing = _.cloneDeep(marketing)
      _.assign(changedMarketing, changes)
    } else {
      changedMarketing = marketing
    }

    let sideEffects = []

    iterateSideEffects(changedMarketing, ({ message }) => {
      sideEffects.push(message)
    })

    return sideEffects
  },

  applySideEffects (marketing) {
    return iterateSideEffects(marketing, ({ action }) => {
      action()
    })
  }
}
